import { useFetchCurrentTime } from "@lhd/hooks";
import { useEffect, useMemo, useRef, useState } from "react";

export function useServerNowMs(enabled: boolean): number | undefined {
  const { data: currentTimeData } = useFetchCurrentTime();
  const lastCurrentDatetimeKeyRef = useRef<string | null>(null);
  const serverTimeAnchorRef = useRef({ serverMs: 0, clientMs: 0 });

  const currentDatetimeKey = currentTimeData?.data?.current_datetime ?? "";
  if (
    currentDatetimeKey &&
    currentDatetimeKey !== lastCurrentDatetimeKeyRef.current &&
    currentTimeData?.datetimeWithTimeRes
  ) {
    lastCurrentDatetimeKeyRef.current = currentDatetimeKey;
    serverTimeAnchorRef.current = {
      serverMs: currentTimeData.datetimeWithTimeRes.getTime(),
      clientMs: Date.now(),
    };
  }

  const [clockTick, setClockTick] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    let intervalId: number | undefined;
    const timeoutId = window.setTimeout(() => {
      setClockTick((n) => n + 1);
      intervalId = window.setInterval(() => setClockTick((n) => n + 1), 1000);
    }, Math.max(0, 1000 - (Date.now() % 1000)));
    return () => {
      window.clearTimeout(timeoutId);
      if (intervalId !== undefined) window.clearInterval(intervalId);
    };
  }, [enabled]);

  return useMemo(() => {
    if (!enabled) return undefined;
    const anchor = serverTimeAnchorRef.current;
    const raw =
      anchor.clientMs > 0
        ? anchor.serverMs + (Date.now() - anchor.clientMs)
        : currentTimeData?.datetimeWithTimeRes?.getTime() ?? Date.now();
    return Math.floor(raw / 1000) * 1000;
  }, [clockTick, currentTimeData?.datetimeWithTimeRes, enabled]);
}
